const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/live/_layout/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/live/_layout')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(itemPanelSearchSchema)
});